// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IUserAccessGetListAttrs,
  IUserAccessGetDetailAttrs,
  IUserAccessUpdateAttrs,
} from 'interfaces/back-office/user-access/user-access-view.interface'

const useUserAccess = () => {
  // Hook
  const {
    userAccess: {
      userAccess_loading,
      userAccess_list,
      userAccess_detail,
      userAccess_CLEAR_LIST,
      userAccess_CLEAR_DETAIL,
      userAccess_fetchList: fetchList,
      userAccess_fetchDetail: fetchDetail,
      userAccess_update: update,
    },
  } = useStores()

  /**
   * @description Fetch user access list
   *
   * @param {IUserAccessGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const userAccess_fetchList = useCallback(
    async (payload: IUserAccessGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Fetch user access detail
   *
   * @param {IUserAccessGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const userAccess_fetchDetail = useCallback(
    async (payload: IUserAccessGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Update user access
   *
   * @param {IUserAccessUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const userAccess_update = useCallback(
    async (payload: IUserAccessUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        update({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [update],
  )

  return {
    userAccess_loading,
    userAccess_list,
    userAccess_detail,
    userAccess_CLEAR_LIST,
    userAccess_CLEAR_DETAIL,
    userAccess_fetchList,
    userAccess_fetchDetail,
    userAccess_update,
  }
}

export { useUserAccess }
